import React from 'react'
import { Icon, IconProps } from '../components/Icon'
const SvgBannerGooglePlayFr: React.FC<IconProps> = (props) => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" {...props}>
      <linearGradient
        id="banner-google-play-fr_svg__a"
        gradientTransform="matrix(1 0 0 -1 0 187)"
        gradientUnits="userSpaceOnUse"
        x1={24.12}
        x2={5.5}
        y1={177.09}
        y2={158.47}
      >
        <stop offset={0} stopColor="#00a0ff" />
        <stop offset={0.01} stopColor="#00a1ff" />
        <stop offset={0.26} stopColor="#00beff" />
        <stop offset={0.51} stopColor="#00d2ff" />
        <stop offset={0.76} stopColor="#00dfff" />
        <stop offset={1} stopColor="#00e3ff" />
      </linearGradient>
      <linearGradient
        id="banner-google-play-fr_svg__b"
        gradientTransform="matrix(1 0 0 -1 0 187)"
        gradientUnits="userSpaceOnUse"
        x1={37.48}
        x2={10.62}
        y1={164.56}
        y2={164.56}
      >
        <stop offset={0} stopColor="#ffe000" />
        <stop offset={0.41} stopColor="#ffbd00" />
        <stop offset={0.78} stopColor="orange" />
        <stop offset={1} stopColor="#ff9c00" />
      </linearGradient>
      <linearGradient
        id="banner-google-play-fr_svg__c"
        gradientTransform="matrix(1 0 0 -1 0 187)"
        gradientUnits="userSpaceOnUse"
        x1={27.48}
        x2={2.23}
        y1={162.02}
        y2={136.76}
      >
        <stop offset={0} stopColor="#ff3a44" />
        <stop offset={1} stopColor="#c31162" />
      </linearGradient>
      <linearGradient
        id="banner-google-play-fr_svg__d"
        gradientTransform="matrix(1 0 0 -1 0 187)"
        gradientUnits="userSpaceOnUse"
        x1={8.03}
        x2={19.3}
        y1={186.56}
        y2={175.29}
      >
        <stop offset={0} stopColor="#32a071" />
        <stop offset={0.07} stopColor="#2da771" />
        <stop offset={0.48} stopColor="#15cf74" />
        <stop offset={0.8} stopColor="#06e775" />
        <stop offset={1} stopColor="#00f076" />
      </linearGradient>
      <rect height={44} rx={7.5} width={149} x={0.5} y={0.5} />
      <path
        d="M142 1a7 7 0 017 7v29a7 7 0 01-7 7H8a7 7 0 01-7-7V8a7 7 0 017-7zm0-1H8a8 8 0 00-8 8v29a8 8 0 008 8h134a8 8 0 008-8V8a8 8 0 00-8-8z"
        fill="#a6a6a6"
      />
      <path d="M-11.17-10.85h172v66.58h-172z" fill="none" />
      <path
        d="M75.54 24.38a4.72 4.72 0 104.74 4.72 4.65 4.65 0 00-4.74-4.72zm0 7.58a2.87 2.87 0 112.66-2.86 2.73 2.73 0 01-2.66 2.9zM65.2 24.38a4.72 4.72 0 104.74 4.72 4.65 4.65 0 00-4.74-4.72zm0 7.58a2.87 2.87 0 112.66-2.86A2.73 2.73 0 0165.2 32zm-12.29-6.13v2h4.79a4.18 4.18 0 01-1.09 2.52 4.9 4.9 0 01-3.7 1.47 5.33 5.33 0 010-10.65 5.11 5.11 0 013.61 1.43l1.41-1.41a7 7 0 00-5-2 7.33 7.33 0 100 14.66A6.7 6.7 0 0058 31.76a6.62 6.62 0 001.73-4.68 6.52 6.52 0 00-.11-1.25zm50.28 1.56a4.39 4.39 0 00-4-3 4.49 4.49 0 00-4.49 4.71 4.62 4.62 0 004.68 4.72 4.69 4.69 0 003.93-2.09l-1.61-1.07A2.7 2.7 0 0199.38 32a2.4 2.4 0 01-2.29-1.43l6.31-2.61zM96.75 29a2.59 2.59 0 012.47-2.75 1.83 1.83 0 011.75 1zm-5.13 4.58h2.07V19.66h-2.07zm-3.4-8.1h-.07a3.27 3.27 0 00-2.49-1.05 4.72 4.72 0 000 9.44 3.22 3.22 0 002.49-1.07h.07v.68c0 1.81-1 2.77-2.52 2.77a2.61 2.61 0 01-2.38-1.68l-1.81.75a4.5 4.5 0 004.18 2.79c2.43 0 4.49-1.43 4.49-4.92v-8.52h-2zM85.85 32a2.87 2.87 0 010-5.72 2.66 2.66 0 012.52 2.88A2.64 2.64 0 0185.85 32zm27.06-12.3h-5v13.83H110v-5.25h2.89a4.31 4.31 0 100-8.62zm.05 6.69H110v-4.8h3a2.38 2.38 0 110 4.76zm12.8-2a3.89 3.89 0 00-3.69 2.12l1.84.77a2 2 0 011.89-1A2 2 0 01128 28v.14a4.58 4.58 0 00-2.16-.54c-2 0-4 1.09-4 3.12a3.2 3.2 0 003.44 3.05 2.92 2.92 0 002.64-1.36h.08v1.07h2v-5.29c0-2.46-1.87-3.84-4.25-3.84zM125.5 32c-.68 0-1.62-.34-1.62-1.18 0-1.07 1.18-1.48 2.2-1.48a3.69 3.69 0 011.89.46 2.51 2.51 0 01-2.47 2.2zm11.74-7.3l-2.37 6h-.07l-2.46-6h-2.23l3.69 8.41-2.11 4.68h2.16l5.69-13.08zm-18.64 8.83h2.07V19.66h-2.07z"
        fill="#fff"
      />
      <path
        d="M11.51 8.61a2.22 2.22 0 00-.51 1.56v24.54a2.22 2.22 0 00.51 1.56l.08.08L25.34 22.6v-.32L11.59 8.53z"
        fill="url(#banner-google-play-fr_svg__a)"
      />
      <path
        d="M29.92 27.18l-4.58-4.58v-.32l4.58-4.58.1.06 5.43 3.09c1.55.88 1.55 2.32 0 3.2L30 27.12z"
        fill="url(#banner-google-play-fr_svg__b)"
      />
      <path
        d="M30 27.12l-4.69-4.69-13.8 13.84a1.81 1.81 0 002.31.07z"
        fill="url(#banner-google-play-fr_svg__c)"
      />
      <path
        d="M30 17.75L13.82 8.54a1.81 1.81 0 00-2.31.07l13.83 13.83z"
        fill="url(#banner-google-play-fr_svg__d)"
      />
      <path
        d="M29.92 27l-16.1 9.17a1.85 1.85 0 01-2.22 0l-.08.08.08.08a1.85 1.85 0 002.22 0L30 27.12z"
        opacity={0.2}
      />
      <path
        d="M11.51 36.1a2.22 2.22 0 01-.51-1.55v.16a2.22 2.22 0 00.51 1.56l.08-.08zm23.95-12.22L29.92 27l.1.1 5.44-3.1a2 2 0 001.16-1.6 2.07 2.07 0 01-1.16 1.48z"
        opacity={0.12}
      />
      <g fill="#fff">
        <path
          d="M13.82 8.7L35.46 21a2.07 2.07 0 011.16 1.44 2 2 0 00-1.16-1.6L13.82 8.54C12.27 7.66 11 8.39 11 10.17v.16c0-1.78 1.27-2.51 2.82-1.63z"
          opacity={0.25}
        />
        <path
          d="M48.78 15.5v-6h1.84a3 3 0 012.21.83 2.94 2.94 0 01.83 2.17 2.94 2.94 0 01-.83 2.17 3 3 0 01-2.21.83zm.77-.74h1.06a2.25 2.25 0 001.65-.6 2.23 2.23 0 00.61-1.67 2.09 2.09 0 00-2.25-2.26h-1.07zm5.19.74v-6h.77v6zm3.83.13a2.24 2.24 0 01-1.28-.43 2 2 0 01-.82-1.2l.7-.28a1.61 1.61 0 00.51.83 1.3 1.3 0 00.88.34 1.4 1.4 0 00.86-.26.84.84 0 00.36-.72.92.92 0 00-.36-.77 3.69 3.69 0 00-1.13-.51A3 3 0 0157.1 12a1.36 1.36 0 01-.41-1 1.49 1.49 0 01.51-1.12 1.87 1.87 0 011.33-.48 1.93 1.93 0 011.24.38 1.76 1.76 0 01.62.83l-.7.29a1 1 0 00-.37-.53 1.31 1.31 0 00-1.53 0 .75.75 0 00-.31.62.7.7 0 00.29.57 2.78 2.78 0 00.85.41 7.23 7.23 0 01.74.28 3.38 3.38 0 01.6.36 1.42 1.42 0 01.46.55 1.79 1.79 0 01.16.77 1.65 1.65 0 01-.18.78 1.46 1.46 0 01-.48.54 2.37 2.37 0 01-.64.31 2.4 2.4 0 01-.71.07zm3.88-.13h-.77v-6h2A1.9 1.9 0 0165 10a1.74 1.74 0 010 2.56 1.89 1.89 0 01-1.32.51h-1.23zm0-3.17h1.29a1 1 0 00.78-.33 1 1 0 000-1.44 1 1 0 00-.78-.33h-1.29zm9.03 2.39a3.12 3.12 0 01-4.4 0 3.07 3.07 0 01-.88-2.22 3.07 3.07 0 01.88-2.22 3.1 3.1 0 014.4 0 3.07 3.07 0 01.89 2.22 3.07 3.07 0 01-.89 2.22zm-3.83-.5a2.31 2.31 0 003.26 0 2.35 2.35 0 00.67-1.72 2.35 2.35 0 00-.67-1.72 2.31 2.31 0 00-3.26 0A2.35 2.35 0 0067 12.5a2.35 2.35 0 00.65 1.72zm5.8 1.28v-6h.94l2.92 4.67V9.5h.77v6h-.8l-3.05-4.89v4.89zm6 0v-6h.77v6zm2.14 0v-6h2.17A1.76 1.76 0 0185 10a1.51 1.51 0 01.52 1.17 1.31 1.31 0 01-.22.75 1.39 1.39 0 01-.59.49 1.52 1.52 0 01.73.52 1.36 1.36 0 01.29.86 1.57 1.57 0 01-.57 1.21 1.85 1.85 0 01-1.28.49zm.77-3.43h1.4a.9.9 0 00.7-.29.89.89 0 000-1.26.86.86 0 00-.67-.29h-1.43zm0 2.69h1.55a.92.92 0 00.72-.31 1 1 0 00.28-.68 1 1 0 00-1-1h-1.55zm4.38.74v-6h.77v5.26h2.6v.74zm7.84-5.26h-2.73v1.9h2.46v.72h-2.46v1.9h2.73v.74h-3.5v-6h3.5zm4.66 5.39a2.24 2.24 0 01-1.24-.42 2 2 0 01-.82-1.2l.7-.28a1.61 1.61 0 00.51.83 1.3 1.3 0 00.88.34 1.4 1.4 0 00.86-.26.84.84 0 00.36-.72.92.92 0 00-.36-.77 3.69 3.69 0 00-1.13-.52 3 3 0 01-1.23-.63 1.36 1.36 0 01-.41-1 1.49 1.49 0 01.51-1.12 1.87 1.87 0 011.33-.48 1.93 1.93 0 011.24.38 1.76 1.76 0 01.62.83l-.7.29a1 1 0 00-.37-.53 1.31 1.31 0 00-1.53 0 .75.75 0 00-.31.62.7.7 0 00.29.57 2.78 2.78 0 00.85.41 7.24 7.24 0 01.74.28 3.38 3.38 0 01.6.36 1.42 1.42 0 01.46.55 1.79 1.79 0 01.16.77 1.65 1.65 0 01-.18.78 1.46 1.46 0 01-.48.54 2.37 2.37 0 01-.64.31 2.4 2.4 0 01-.71.07zm5.2 0a2.11 2.11 0 01-1.61-.65 2.39 2.39 0 01-.62-1.71V9.5h.79v3.8a1.72 1.72 0 00.37 1.15 1.54 1.54 0 002.15 0 1.72 1.72 0 00.37-1.15V9.5h.77v3.77a2.43 2.43 0 01-.6 1.71 2.1 2.1 0 01-1.62.65zm3.46-.13v-6h2a1.9 1.9 0 011.32.51 1.73 1.73 0 01.15 2.39 1.78 1.78 0 01-1 .61l1.68 2.44h-.91l-1.62-2.43h-.86v2.48zm.77-3.15h1.24a1.13 1.13 0 00.79-.3 1 1 0 00.33-.76 1.06 1.06 0 00-.29-.72 1 1 0 00-.78-.33h-1.29z"
          stroke="#fff"
          strokeMiterlimit={10}
          strokeWidth={0.2}
        />
      </g>
    </Icon>
  )
}
export default SvgBannerGooglePlayFr
